import * as _ from 'lodash-es';

const generateDeltaRandomId = () =>
  _.times(8, () => _.random(35).toString(36)).join('');

export default generateDeltaRandomId;
